import React from "react";
import { epdEditorStore } from "../EPDEditorStore";
import { useTranslation } from "react-i18next";
import DynamicDropdown, { Option } from "components/DynamicDropdown";
import { observer } from "mobx-react-lite";

const Materials = () => {
  const { t } = useTranslation();
  const [options, setOptions] = React.useState<Option[]>([]);

  React.useEffect(() => {
    fetchMaterials("");
  }, []);

  const fetchMaterials = async (searchTerm: string) => {
    return await epdEditorStore.fetchMaterials(searchTerm).then((response) => {
      if (!searchTerm) {
        const data = {
          items: response,
          count: response.length,
        };
        setOptions(data.items);
        return data;
      } else {
        // only returns children
        const items: Option[] = [];
        response.forEach((rec) => {
          rec.children?.map((child) => {
            items.push(child);
          });
        });
        setOptions(items);
        return { items: items, count: items.length };
      }
    });
  };

  return (
    <div className="border-b border-gray-200 py-6">
      <div className="text-base font-semibold mb-4">
        {t("EPDEditor.materiality")}
      </div>
      <div className="flex gap-4 w-full justify-between">
        <DynamicDropdown
          labelName="Material"
          placeholder={t("EPDEditor.searchOrSelect")}
          helper={t("EPDEditor.materialHelper")}
          containerClassName="w-full"
          options={options}
          fetchOptions={fetchMaterials}
          value={epdEditorStore.data.default_material_name}
          onSelect={(item) =>
            epdEditorStore.onChangeData("default_material_name", item?.name)
          }
        />
      </div>
    </div>
  );
};

export default observer(Materials);
